import { Layout, theme, Grid } from "antd";
import React from "react";

const { Header, Content } = Layout;


export interface SubPageLayoutProps {
  header: React.JSX.Element;
  children?: React.ReactNode;
}

export const SubPageLayout: React.FC<SubPageLayoutProps> = (props) => {
  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;

  const {
    token: { colorText },
  } = theme.useToken();
  return (
    <Layout>
      <Header style={{ padding: 0, height: "fit-content", color: colorText, backgroundColor: "transparent" }}>{props.header}</Header>
      <Content
        style={{
          marginTop: isMobile ? "120px" : "100px",
          display: "flex",
          flexDirection: "column",
          paddingBottom: '90px',
        }}
      >
        {props.children}
      </Content>
    </Layout>
  );
};
